import dayjs from "dayjs";
import React from "react";
import Config from "../../util/config";

export interface Props {
  className?: string;
  classNameDay?: string;
  clickable: boolean;
  onClick?: (day: dayjs.Dayjs) => void;
  day: dayjs.Dayjs;
  attributes: Record<string, string>;
}

const Day = (props: Props) => {
  const { day, className, classNameDay } = props;
  const onClick = props.clickable ? props.onClick : () => {};

  return (
    <span
      onClick={() => onClick(day)}
      className={className || ""}
      {...props.attributes}
    >
      <span className={classNameDay || ""}>
        {day.format(Config.get("dayFormat", "D"))}
      </span>
    </span>
  );
};

export default Day;
